import { render } from "./MatcherSmsDialog.vue?vue&type=template&id=0bf21ce0&scoped=true"
import script from "./MatcherSmsDialog.vue?vue&type=script&lang=js"
export * from "./MatcherSmsDialog.vue?vue&type=script&lang=js"

import "./MatcherSmsDialog.vue?vue&type=style&index=0&id=0bf21ce0&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf21ce0"]])

export default __exports__